<div #formRow class="form-group" [ngClass]="{ 'mb-0': noMarginBottom }">
  @if (label && label.length && !isHsCode) {
    <label class="d-flex justify-content-between">
      <span class="inline-flex-gap-5 align-items-center">
        {{ label | translate }}
        @if (tooltipLabel && tooltipLabel.length > 0) {
          <info-tooltip [label]="tooltipLabel" [icon]="tooltipIcon"></info-tooltip>
        }
      </span>
      @if (required) {
        <label class="float-right required"> ({{ 'required' | translate }}) </label>
      }
    </label>
  }

  @if (isHsCode) {
    <label class="d-flex justify-content-between">
      @if (label && label.length) {
        <label>
          {{ label | translate }}
        </label>
      }
      <label class="float-right hs-code">
        <a href="https://www.tariffnumber.com/" target="_blank">
          {{ 'number.hsCode' | translate }}
          <i class="far fa-external-link"></i>
        </a>
      </label>
    </label>
  }
  <div class="input-group">
    @if (inputDisabled) {
      <input
        [ngClass]="{
          'login-input': isLoginInput,
          'is-invalid': requiredCssClass,
          is_pristine: control && control.pristine,
          is_valid: control && !control.pristine && control.valid,
          is_invalid: control && !control.pristine && !control.valid
        }"
        class="form-control"
        [type]="inputType"
        [pattern]="pattern"
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [attr.accept]="inputAccept || null"
        [attr.data-cy]="dataCyAttribute"
        [autocomplete]="autocomplete"
        disabled
      />
    }
    @if (!inputDisabled && !translateBarcode && !replaceComma && !inputMultiple) {
      <input
        #formRowInput
        [ngClass]="{
          'login-input': isLoginInput,
          'is-invalid': requiredCssClass,
          is_pristine: control && control.pristine,
          is_valid: control && !control.pristine && control.valid,
          is_invalid: control && !control.pristine && !control.valid
        }"
        class="form-control"
        [type]="inputType"
        [pattern]="pattern"
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [attr.accept]="inputAccept || null"
        (ngModelChange)="onNgModelChange($event, maximumVal)"
        (keyup)="onInputKeyPress($event)"
        (change)="onInputValueChange($event)"
        (focus)="onFocus(true)"
        (blur)="onFocus(false)"
        [attr.data-track-category]="trackCategory"
        [attr.data-track-action]="trackAction"
        [required]="inputRequired"
        [min]="minimumVal"
        [max]="maximumVal"
        [attr.name]="elementName"
        [placeholder]="(placeholder | translate) ?? ''"
        [attr.data-cy]="dataCyAttribute"
        [autocomplete]="autocomplete"
        [readonly]="isReadonlyForAutofill"
      />
    }
    @if (!inputDisabled && translateBarcode && !replaceComma && !inputMultiple) {
      <input
        [ngClass]="{
          'login-input': isLoginInput,
          'is-invalid': requiredCssClass,
          is_pristine: control && control.pristine,
          is_valid: control && !control.pristine && control.valid,
          is_invalid: control && !control.pristine && !control.valid
        }"
        class="form-control"
        [type]="inputType"
        [pattern]="pattern"
        translateBarcode
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [attr.accept]="inputAccept || null"
        (ngModelChange)="onNgModelChange($event)"
        (keyup)="onInputKeyPress($event)"
        (focus)="onFocus(true)"
        (blur)="onFocus(false)"
        [attr.data-track-category]="trackCategory"
        [attr.data-track-action]="trackAction"
        [required]="inputRequired"
        [min]="minimumVal"
        [max]="maximumVal"
        [attr.name]="elementName"
        [attr.data-cy]="dataCyAttribute"
        [autocomplete]="autocomplete"
      />
    }
    @if (!inputDisabled && !translateBarcode && replaceComma && !inputMultiple) {
      <input
        [ngClass]="{
          'login-input': isLoginInput,
          'is-invalid': requiredCssClass,
          is_pristine: control && control.pristine,
          is_valid: control && !control.pristine && control.valid,
          is_invalid: control && !control.pristine && !control.valid
        }"
        class="form-control"
        [type]="inputType"
        [pattern]="pattern"
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [attr.accept]="inputAccept || null"
        (ngModelChange)="onNgModelChange($event)"
        (keyup)="onInputKeyPress($event)"
        (focus)="onFocus(true)"
        (blur)="onFocus(false)"
        [attr.data-track-category]="trackCategory"
        [attr.data-track-action]="trackAction"
        [required]="inputRequired"
        [min]="minimumVal"
        [max]="maximumVal"
        [attr.name]="elementName"
        [attr.data-cy]="dataCyAttribute"
        [autocomplete]="autocomplete"
      />
    }
    @if (!inputDisabled && translateBarcode && replaceComma && !inputMultiple) {
      <input
        [ngClass]="{
          'login-input': isLoginInput,
          'is-invalid': requiredCssClass,
          is_pristine: control && control.pristine,
          is_valid: control && !control.pristine && control.valid,
          is_invalid: control && !control.pristine && !control.valid
        }"
        class="form-control"
        [type]="inputType"
        [pattern]="pattern"
        translateBarcode
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [attr.accept]="inputAccept || null"
        (ngModelChange)="onNgModelChange($event)"
        (keyup)="onInputKeyPress($event)"
        (focus)="onFocus(true)"
        (blur)="onFocus(false)"
        [attr.data-track-category]="trackCategory"
        [attr.data-track-action]="trackAction"
        [required]="inputRequired"
        [min]="minimumVal"
        [max]="maximumVal"
        [attr.name]="elementName"
        [attr.data-cy]="dataCyAttribute"
        [autocomplete]="autocomplete"
      />
    }
    @if (!inputDisabled && !translateBarcode && !replaceComma && inputMultiple) {
      <input
        [ngClass]="{
          'login-input': isLoginInput,
          'is-invalid': requiredCssClass,
          is_pristine: control && control.pristine,
          is_valid: control && !control.pristine && control.valid,
          is_invalid: control && !control.pristine && !control.valid
        }"
        class="form-control"
        [type]="inputType"
        [pattern]="pattern"
        multiple
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [attr.accept]="inputAccept || null"
        (ngModelChange)="onNgModelChange($event)"
        (keyup)="onInputKeyPress($event)"
        (change)="onInputValueChange($event)"
        (focus)="onFocus(true)"
        (blur)="onFocus(false)"
        [attr.data-track-category]="trackCategory"
        [attr.data-track-action]="trackAction"
        [required]="inputRequired"
        [min]="minimumVal"
        [max]="maximumVal"
        [attr.name]="elementName"
        [attr.data-cy]="dataCyAttribute"
        [autocomplete]="autocomplete"
      />
    }
    <ng-content></ng-content>
    @if (appendUnitCm) {
      <span class="input-group-unit my-auto ms-1 me-1"><strong>cm</strong></span>
    }
    @if (appendUnitKg) {
      <span class="input-group-unit my-auto ms-1 me-1"><strong>kg</strong></span>
    }
    @if (appendUnitCurrency) {
      <span class="input-group-unit my-auto ms-1 me-1"
        ><strong>{{ currency | formatCurrencyWithoutPrice }}</strong></span
      >
    }
    @if (appendUnitPercent) {
      <span class="input-group-unit my-auto ms-1 me-1"><strong>%</strong></span>
    }
    @if (appendUnitCustom?.length) {
      <span class="input-group-unit my-auto ms-1 me-1"
        ><strong>{{ appendUnitCustom }}</strong></span
      >
    }
    @if ((appendBtnLabel && appendBtnLabel.length > 0) || (appendBtnIcon && appendBtnIcon.length > 0)) {
      <div class="input-group-append">
        <btn
          [label]="appendBtnLabel"
          [classes]="appendBtnClasses"
          [icon]="appendBtnIcon"
          [title]="appendBtnTitle | translate"
          [isLoading]="appendBtnIsLoading"
          [dataCyAttribute]="'append-btn'"
          (onEvent)="onBtnClick($event)"
        ></btn>
      </div>
    }
    @if (appendCheckboxValue !== null && appendCheckboxShow) {
      <div class="input-group-append">
        <div class="input-group-text">
          <label class="mb-0">
            <input
              type="checkbox"
              class="cursor-pointer"
              [ngModel]="appendCheckboxValue"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onAppendedCheckboxChange($event)"
              [attr.data-cy]="dataCyAttribute"
            />
            {{ appendCheckboxLabel }}
          </label>
        </div>
      </div>
    }
    @if (appendCheckboxValue !== null && appendToggleShow) {
      <div class="input-group-append d-flex align-items-center">
        <div class="custom-control custom-switch flex-gap-5 ms-2">
          <input
            type="checkbox"
            class="custom-control-input"
            [id]="label + '_toggle'"
            tabindex="0"
            [ngModel]="appendCheckboxValue"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onAppendedCheckboxChange($event)"
            [attr.data-track-category]="trackCategory"
            [attr.data-track-action]="trackAction"
            [attr.data-cy]="dataCyAttributeAppendToggle"
          />
          <label class="custom-control-label" [for]="label + '_toggle'" data-cy="toggle-in-input"> </label>
        </div>
      </div>
    }
    @if (requiredCssClass) {
      <div [ngClass]="{ 'invalid-feedback': requiredCssClass }" style="color: #f0142f" data-cy="error_msg">
        {{ errors | formError: formControlName | translate }}
      </div>
    }
  </div>
  @if (showMessageMaxValue && label === 'quantity') {
    <div class="text-start">
      {{ 'form-row-input.max-value-message' | translate: { quantity: maximumVal } }}
    </div>
  }
</div>
